import { getSolarRecommand } from '@/service/solar-calculator';
import { useGlobal } from '@/utils/useGlobal';
import { getIsMobileWidth2 } from '@elem/utils/devices';
import EcoDesignEventsBus from 'eco-design-micro/EcoDesignEventsBus';
import { ENUM_ECO_CART_EVENT, ItfEcoCartItem } from 'eco-design/elements/eco-cart/type.d';
import EFPicture from 'elem/compCommon/EFPicture';
import { Scrollbar } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import VanlifeTripsH from '../../components/VanlifeRoadtripsH';
import J_NA from './components/J';
import css from './index.module.scss';

export default function K() {
    const { useLang, useState, useEffect, useRouter, Link, gtm } = useGlobal();
    const { t } = useLang('outdoorrecreation');
    const { locale } = useRouter();
    // const ZA_SITE: string[] = ['za'];
    const isMobile = getIsMobileWidth2(); //是否是移动端

    const [pageLoaded, setPageLoaded] = useState(false);

    const cards: any = [
        {
            sort: 1,
            // img: ['us', 'ca'].includes(locale)
            //     ? ''
            //     : `/responsive/picture/common-products/wave${ZA_SITE.includes(locale) ? '' : '2'}${!['us', 'za'].includes(locale) ? '_C' : ''}.png`,
            title: t('secK_card1_title'),
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-wave-3-portable-air-conditioner-with-heater',
                    de: 'https://de.ecoflow.com/products/wave-2-portable-air-conditioner',
                    za: 'https://za.ecoflow.com/products/ecoflow-wave-portable-air-conditioner',
                    fr: 'https://fr.ecoflow.com/products/wave-2-portable-air-conditioner',
                    eu: 'https://eu.ecoflow.com/products/wave-2-portable-air-conditioner',
                    uk: 'https://uk.ecoflow.com/products/wave-2-portable-air-conditioner',
                    it: 'https://it.ecoflow.com/products/wave-2-portable-air-conditioner',
                    es: 'https://es.ecoflow.com/products/wave-2-portable-air-conditioner',
                    au: 'https://au.ecoflow.com/products/wave-2-portable-air-conditioner',
                    kr: 'https://kr.ecoflow.com/products/wave-2-portable-air-conditioner',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7414779576393',
                    ca: '15052470157683',
                    de: '8376354537807',
                    za: '7155609665745',
                    fr: '8370477728091',
                    eu: '8368405807447',
                    uk: '8376008704339',
                    it: '8368685220189',
                    es: '8370477138267',
                    au: '7795796410566',
                    kr: '7737145655465',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '42093673021513',
                    ca: '52405151662451',
                    de: '46538134126927',
                    za: '41347453386961',
                    fr: '46505472164187',
                    eu: '46493661954391',
                    uk: '46526037786963',
                    it: '46532250698077',
                    es: '46505471508827',
                    au: '42713053593798',
                    kr: '43039193956521',
                };
                return localMap[locale] || localMap.us;
            })(),
            descArr: [t('secK_card1_desc1'), t('secK_card1_desc2'), t('secK_card1_desc3'), t('secK_card1_desc4'), t('secK_card1_desc5')],
        },
        {
            sort: 2,
            showGoodDesign: !!['au'].includes(locale),
            // img: ['us', 'ca'].includes(locale) ? '' : `/responsive/picture/common-products/glacier${!['us'].includes(locale) ? '_C' : ''}.png`,
            title: t('secK_card2_title'),
            // tag: ZA_SITE.includes(locale) ? t('common_card_tag_coming_soon') : '',
            link_more: (() => {
                const localMap: any = {
                    us: 'https://us.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-fridge-freezer',
                    ca: 'https://ca.ecoflow.com/products/ecoflow-glacier-classic-55l-portable-fridge-freezer',
                    de: 'https://de.ecoflow.com/products/glacier-portable-refrigerator',
                    za: 'https://za.ecoflow.com/products/glacier-portable-refrigerator',
                    fr: 'https://fr.ecoflow.com/products/glacier-portable-refrigerator',
                    eu: 'https://eu.ecoflow.com/products/glacier-portable-refrigerator',
                    uk: 'https://uk.ecoflow.com/products/glacier-portable-refrigerator',
                    it: 'https://it.ecoflow.com/products/glacier-portable-refrigerator',
                    es: 'https://es.ecoflow.com/products/glacier-portable-refrigerator',
                    au: 'https://au.ecoflow.com/products/glacier-portable-refrigerator',
                    kr: 'https://kr.ecoflow.com/products/glacier-portable-refrigerator',
                };
                return localMap[locale] || localMap.us;
            })(),
            productId: (() => {
                const localMap: any = {
                    us: '7414796615753',
                    ca: '15052472680819',
                    de: '8376354472271',
                    fr: '8370479890779',
                    eu: '8364025938263',
                    uk: '8376008474963',
                    it: '8368685089117',
                    es: '8370476974427',
                    au: '7795792412870',
                    za: '7322399834321',
                    kr: '7738246856873',
                };
                return localMap[locale] || localMap.us;
            })(),
            variantId: (() => {
                const localMap: any = {
                    us: '42093744685129',
                    ca: '52405173059955',
                    de: '46538133733711',
                    fr: '46505478881627',
                    eu: '46496798769495',
                    uk: '46526037360979',
                    it: '46532250435933',
                    es: '46505471213915',
                    au: '42713036128454',
                    za: '41834564452561',
                    kr: '43039330369705',
                };
                return localMap[locale] || localMap.us;
            })(),
            // za站的glacier没有对应的shopify产品，跳转官网glacier预热页
            // notShopifySites: ['za'],
            descArr: [t('secK_card2_desc1'), t('secK_card2_desc2'), t('secK_card2_desc3'), t('secK_card2_desc4'), t('secK_card2_desc5')],
        },
        ...(['us', 'ca'].includes(locale)
            ? [
                  {
                      sort: 3,
                      showGoodDesign: !!['au'].includes(locale),
                      //   img: '',
                      title: t('secK_card6_title'),
                      // tag: ZA_SITE.includes(locale) ? t('common_card_tag_coming_soon') : '',
                      link_more: (() => {
                          const localMap: any = {
                              us: 'https://us.ecoflow.com/products/45w-portable-solar-panel?variant=41731341353033',
                              ca: 'https://ca.ecoflow.com/products/45w-portable-solar-panel?variant=52438137438579',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      productId: (() => {
                          const localMap: any = {
                              us: '7264162676809',
                              ca: '8292312449178',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      variantId: (() => {
                          const localMap: any = {
                              us: '41731341353033',
                              ca: '52438137438579',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      // za站的glacier没有对应的shopify产品，跳转官网glacier预热页
                      // notShopifySites: ['za'],
                      descArr: [t('secK_card6_desc1'), t('secK_card6_desc2'), t('secK_card6_desc3'), t('secK_card6_desc4'), t('secK_card6_desc5')],
                  },
                  {
                      sort: 4,
                      showGoodDesign: !!['au'].includes(locale),
                      img: ``,
                      title: t('secK_card7_title'),
                      // tag: ZA_SITE.includes(locale) ? t('common_card_tag_coming_soon') : '',
                      link_more: (() => {
                          const localMap: any = {
                              us: 'https://us.ecoflow.com/products/solar-power-hat?variant=41629165748297',
                              ca: 'https://ca.ecoflow.com/products/solar-power-hat?variant=45132589990042',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      productId: (() => {
                          const localMap: any = {
                              us: '7288411619401',
                              ca: '8321102971034',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      variantId: (() => {
                          const localMap: any = {
                              us: '41629165748297',
                              ca: '45132589990042',
                          };
                          return localMap[locale] || localMap.us;
                      })(),
                      // za站的glacier没有对应的shopify产品，跳转官网glacier预热页
                      // notShopifySites: ['za'],
                      descArr: [t('secK_card7_desc1'), t('secK_card7_desc2'), t('secK_card7_desc3'), t('secK_card7_desc4'), t('secK_card7_desc5')],
                  },
              ]
            : []),
    ];

    const [cardLists, setCardLists] = useState(cards);

    const handleBuy = (card: any) => {
        try {
            gtm.push({
                event: 'uaEvent',
                event_name: 'bundle_add_to_cart',
                list_name: t('secK_title'),
                product_name: card?.title || card?.productTitle || card?.skuTitle,
                price: card?.price,
                tag: card?.tag || 'none',
                quantity: 1,
                button_name: t('common_card_buy') || 'Buy Now',
            });
            // @ts-ignore
            window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.error(e);
        } finally {
            const { price, compareAtPrice, inventoryPolicy, inventoryQuantity, productId, variantId, variantImg, img, productTitle, skuTitle } = card;
            EcoDesignEventsBus.emit(ENUM_ECO_CART_EVENT.ECO_CART_ADD, [
                {
                    price,
                    compareAtPrice,
                    inventoryPolicy,
                    inventoryQuantity,
                    productId,
                    variantId,
                    variantImg,
                    img,
                    productTitle,
                    skuTitle,
                    quantity: 1,
                } as ItfEcoCartItem,
            ]);
        }
    };

    useEffect(() => {
        const tempArr = [...cards.filter((card: any) => !card?.notShopifySites?.includes(locale))];
        const otherArr = [...cards.filter((card: any) => card?.notShopifySites?.includes(locale))];
        const getAsynItem = async (productId: string, variantId: string, k: number) => {
            return await new Promise(async (resolve, reject) => {
                try {
                    const res = await getSolarRecommand({ productId, variantId }, locale);
                    if (res?.code === '0') {
                        if (res?.data?.handle) {
                            tempArr[k].link_more = `https://${locale}.ecoflow.com/products/${res?.data?.handle}?variant=${variantId}`;
                        }
                        tempArr[k].link_buy = `https://${locale}.ecoflow.com/cart/${variantId}:1?channel=buy_button`;
                        return resolve({ ...tempArr?.[k], ...res?.data });
                    } else {
                        console.error(res?.message);
                        return reject({ ...tempArr?.[k] });
                    }
                } catch (e) {
                    console.error(e);
                    return reject({ ...tempArr?.[k] });
                }
            });
        };
        const promises = tempArr?.map((item: any, k: number) => getAsynItem(item?.productId, item.variantId, k));
        Promise.all(promises)
            .then((res: any) => {
                const _data = [...res, ...otherArr].sort((a, b) => a.sort - b.sort);
                setCardLists(_data);
            })
            .catch((e) => {
                console.error(e);
            });

        setPageLoaded(true);
    }, []);

    return (
        <div id="outdoor-recreation-K" className={`outdoor-recreation-K ${css['outdoor-recreation-K']}`}>
            {!isMobile ? (
                <>
                    <div className="ef-box">
                        {cardLists.slice(0, 2).map((card: any, k: number) => (
                            <div className="item item-align" key={k}>
                                {card?.tag && <span className="card-tag">{card?.tag}</span>}
                                {card?.showGoodDesign && (
                                    <div className="card-good-design">
                                        <EFPicture src="/responsive/picture/good_design.png" alt={card?.title} />
                                    </div>
                                )}
                                <div className="card-img">
                                    <EFPicture src={card?.img} alt={card?.title} />
                                </div>
                                <div className="card-info">
                                    <p className="card-title">{card?.title}</p>
                                    <ul className="card-descs">
                                        {card?.descArr?.map((desc: any, m: number) => (
                                            <li className="card-desc" key={`${k}_${m}`}>
                                                {desc}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="card-btns">
                                        {card?.link_more && (
                                            <Link
                                                className="btn-more card-btn"
                                                href={`${card?.link_more}${
                                                    card?.notShopifySites?.includes(locale)
                                                        ? ''
                                                        : `${card?.link_more?.indexOf('?') !== -1 ? '&' : '?'}utm_source=scenario+page&utm_medium=Pillar`
                                                }`}
                                                target="_blank"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'select_product',
                                                    list_name: t('secK_title'),
                                                    product_name: card.title,
                                                    button_name: t('common_card_more'),
                                                }}
                                            >
                                                {t('common_card_more')}
                                            </Link>
                                        )}
                                        {card?.link_buy && (
                                            <>
                                                {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'contine' ? (
                                                    <button disabled className={`btn-buy card-btn disable`}>
                                                        {t('common_card_out')}
                                                    </button>
                                                ) : (
                                                    <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                        {t('common_card_buy')}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                    <J_NA />
                    <VanlifeTripsH />
                    {/* <div className="ef-box">
                        {cardLists.slice(2, 4).map((card: any, k: number) => (
                            <div className="item" key={k}>
                                {card?.tag && <span className="card-tag">{card?.tag}</span>}
                                {card?.showGoodDesign && (
                                    <div className="card-good-design">
                                        <EFPicture src="/responsive/picture/good_design.png" alt={card?.title} />
                                    </div>
                                )}
                                <div className="card-img">
                                    <EFPicture src={card?.img} alt={card?.title} />
                                </div>
                                <div className="card-info">
                                    <p className="card-title">{card?.title}</p>
                                    <ul className="card-descs">
                                        {card?.descArr?.map((desc: any, m: number) => (
                                            <li className="card-desc" key={`${k}_${m}`}>
                                                {desc}
                                            </li>
                                        ))}
                                    </ul>
                                    <div className="card-btns">
                                        {card?.link_more && (
                                            <Link
                                                className="btn-more card-btn"
                                                href={`${card?.link_more}${
                                                    card?.notShopifySites?.includes(locale)
                                                        ? ''
                                                        : `${card?.link_more?.indexOf('?') !== -1 ? '&' : '?'}utm_source=scenario+page&utm_medium=Pillar`
                                                }`}
                                                target="_blank"
                                                dataLayer={{
                                                    event: 'uaEvent',
                                                    event_name: 'select_product',
                                                    list_name: t('secK_title'),
                                                    product_name: card.title,
                                                    button_name: t('common_card_more'),
                                                }}
                                            >
                                                {t('common_card_more')}
                                            </Link>
                                        )}
                                        {card?.link_buy && (
                                            <>
                                                {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'contine' ? (
                                                    <button disabled className={`btn-buy card-btn disable`}>
                                                        {t('common_card_out')}
                                                    </button>
                                                ) : (
                                                    <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                        {t('common_card_buy')}
                                                    </p>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div> */}
                </>
            ) : pageLoaded ? (
                <>
                    <div className="ef-box">
                        <Swiper
                            className="cards swiper-box swiper-box1"
                            effect="fade"
                            modules={[Scrollbar]}
                            spaceBetween={16}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            allowTouchMove={isMobile}
                            scrollbar={{
                                hide: false,
                                draggable: true,
                                dragSize: 32,
                                snapOnRelease: true,
                            }}
                        >
                            {cardLists.slice(0, 2)?.map((card: any, k: number) => (
                                <SwiperSlide className={`item item-${k + 1}`} key={k}>
                                    {card?.tag && <span className="card-tag">{card?.tag}</span>}
                                    {card?.showGoodDesign && (
                                        <div className="card-good-design">
                                            <EFPicture src="/responsive/picture/good_design.png" alt={card?.title} />
                                        </div>
                                    )}
                                    <div className="card-img">
                                        <EFPicture src={card?.variantImg || card?.img} alt={card?.title || card?.productTitle || card?.skuTitle} />
                                    </div>
                                    <div className="card-info">
                                        <p className="card-title">{card?.title || card?.productTitle || card?.skuTitle}</p>
                                        <ul className="card-descs">
                                            {card?.descArr?.map((desc: any, m: number) => (
                                                <li className="card-desc" key={`${k}_${m}`}>
                                                    {desc}
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="card-btns">
                                            {card?.link_more && (
                                                <Link
                                                    className="btn-more card-btn"
                                                    href={`${card?.link_more}${
                                                        card?.notShopifySites?.includes(locale)
                                                            ? ''
                                                            : `${card?.link_more?.indexOf('?') !== -1 ? '&' : '?'}utm_source=scenario+page&utm_medium=Pillar`
                                                    }`}
                                                    target="_blank"
                                                    dataLayer={{
                                                        event: 'uaEvent',
                                                        event_name: 'select_product',
                                                        list_name: t('secK_title'),
                                                        product_name: card.title,
                                                        button_name: t('common_card_more'),
                                                    }}
                                                >
                                                    {t('common_card_more')}
                                                </Link>
                                            )}
                                            {card?.link_buy && (
                                                <>
                                                    {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'contine' ? (
                                                        <button disabled className={`btn-buy card-btn disable`}>
                                                            {t('common_card_out')}
                                                        </button>
                                                    ) : (
                                                        <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                            {t('common_card_buy')}
                                                        </p>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                    <J_NA />
                    <VanlifeTripsH />
                    {/* <div className="ef-box">
                        <Swiper
                            className="cards swiper-box swiper-box2"
                            effect="fade"
                            modules={[Scrollbar]}
                            spaceBetween={16}
                            slidesPerView={'auto'}
                            initialSlide={0}
                            allowTouchMove={isMobile}
                            scrollbar={{
                                hide: false,
                                draggable: true,
                                dragSize: 32,
                                snapOnRelease: true,
                            }}
                        >
                            {cardLists.slice(2, 4)?.map((card: any, k: number) => (
                                <SwiperSlide className={`item item-${k + 1}`} key={k}>
                                    {card?.tag && <span className="card-tag">{card?.tag}</span>}
                                    {card?.showGoodDesign && (
                                        <div className="card-good-design">
                                            <EFPicture src="/responsive/picture/good_design.png" alt={card?.title} />
                                        </div>
                                    )}
                                    <div className="card-img">
                                        <EFPicture src={card?.img} alt={card?.title} />
                                    </div>
                                    <div className="card-info">
                                        <p className="card-title">{card?.title}</p>
                                        <ul className="card-descs">
                                            {card?.descArr?.map((desc: any, m: number) => (
                                                <li className="card-desc" key={`${k}_${m}`}>
                                                    {desc}
                                                </li>
                                            ))}
                                        </ul>
                                        <div className="card-btns">
                                            {card?.link_more && (
                                                <Link
                                                    className="btn-more card-btn"
                                                    href={`${card?.link_more}${
                                                        card?.notShopifySites?.includes(locale)
                                                            ? ''
                                                            : `${card?.link_more?.indexOf('?') !== -1 ? '&' : '?'}utm_source=scenario+page&utm_medium=Pillar`
                                                    }`}
                                                    target="_blank"
                                                    dataLayer={{
                                                        event: 'uaEvent',
                                                        event_name: 'select_product',
                                                        list_name: t('secK_title'),
                                                        product_name: card.title,
                                                        button_name: t('common_card_more'),
                                                    }}
                                                >
                                                    {t('common_card_more')}
                                                </Link>
                                            )}
                                            {card?.link_buy && (
                                                <>
                                                    {Number(card?.inventoryQuantity || 0) <= 0 && card?.inventoryPolicy !== 'contine' ? (
                                                        <button disabled className={`btn-buy card-btn disable`}>
                                                            {t('common_card_out')}
                                                        </button>
                                                    ) : (
                                                        <p className={`btn-buy card-btn`} onClick={() => handleBuy(card)}>
                                                            {t('common_card_buy')}
                                                        </p>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div> */}
                </>
            ) : null}
        </div>
    );
}
